export default __webpack_public_path__ + "static/media/640_dummy2016-nagelstudio01-mobile-de.5cf56b09.png";